import React from 'react';
import {
  KeyboardAvoidingView as RNKeyboardAvoidingView,
  StatusBar,
  StyleSheet,
  View,
} from 'react-native';
import { SafeAreaView as RNSafeAreaView, SafeAreaViewProps } from 'react-native-safe-area-context';

import ActivityIndicator from '@components/ActivityIndicator';
import { HeaderHeightContext } from '@react-navigation/elements';

type RowProps = React.ComponentProps<typeof View>;

export function Row({ style, ...props }: RowProps) {
  return <View style={[styles.row, style]} {...props} />;
}

export function SafeAreaView(props: SafeAreaViewProps) {
  return <RNSafeAreaView {...props} />;
}

type KeyboardAvoidingViewProps = Omit<
  React.ComponentProps<typeof RNKeyboardAvoidingView>,
  'behavior'
>;

export function KeyboardAvoidingView({ style, ...props }: KeyboardAvoidingViewProps) {
  const headerHeight = React.useContext(HeaderHeightContext) ?? 0;

  const verticalOffset = headerHeight + (StatusBar.currentHeight || 0);

  return (
    <RNKeyboardAvoidingView
      behavior="padding"
      keyboardVerticalOffset={verticalOffset}
      style={[styles.container, style]}
      {...props}
    />
  );
}

type LoadingViewProps = React.ComponentProps<typeof View> & {
  loading: boolean;
  indicatorSize: React.ComponentProps<typeof ActivityIndicator>['size'];
};

export function LoadingView({
  loading,
  indicatorSize,
  children,
  style,
  ...props
}: LoadingViewProps) {
  return loading ? (
    <View style={[styles.loadingContainer, style]} {...props}>
      <ActivityIndicator
        size={indicatorSize}
        testID={props.testID + '.ActivityIndicator'}
        style={styles.indicator}
      />
    </View>
  ) : (
    <View style={style} {...props}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  indicator: {
    padding: 20,
  },
  loadingContainer: {
    alignContent: 'center',
    justifyContent: 'center',
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
  },
});
